// --- GLOBAL CART UPDATE LOCK (prevents double add/change on slow networks) ---
window.__cartUpdating = false;
window.withCartLock = async function (fn) {
  while (window.__cartUpdating) {
    await new Promise(r => setTimeout(r, 30));
  }
  window.__cartUpdating = true;
  try {
    return await fn();
  } finally {
    setTimeout(() => { window.__cartUpdating = false }, 150);
  }
};

console.log("TRACE: cart.js loaded");
// Wrapper to trace calls
function traceCall(stepName, data = {}) {
  console.log("TRACE:", stepName, data);
}



// Smooth collapse helper (same timing as before)
function smoothCollapse(el) {
  if (!el) return;
  const h = el.getBoundingClientRect().height;
  el.style.boxSizing = 'border-box';
  el.style.height = h + 'px';
  el.style.transition = 'height .25s ease, opacity .25s ease, margin .25s ease, padding .25s ease';
  el.style.overflow = 'hidden';
  // force reflow
  void el.offsetHeight;
  el.style.opacity = '0';
  el.style.marginTop = '0';
  el.style.marginBottom = '0';
  el.style.paddingTop = '0';
  el.style.paddingBottom = '0';
  el.style.height = '0px';
}

async function updateCartCountBubble() {
    try {
    const cart = await fetch('/cart.js', {
      credentials: 'same-origin',
      cache: 'no-store'
    }).then(r => r.json());
    const num = cart.item_count || 0;
    const headerCountEl = document.querySelector('#cart-icon-bubble .cart-count');
    if (!headerCountEl) return;
    headerCountEl.textContent = num;
    console.log("UPDATED CART COUNT →", num);
  } catch (e) {
    console.warn("Cart count update failed:", e);
  }
}

// Replace your existing definition with this:
class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      const index = this.dataset.index;
      if (!index) return;
      const cartItemsHost =
        this.closest('cart-items') ||
        this.closest('cart-drawer-items');
      const row =
        document.getElementById(`CartItem-${index}`) ||
        document.getElementById(`CartDrawer-Item-${index}`) ||
        this.closest('tr.cart-item');
      if (row && document.body.contains(row)) {
        smoothCollapse(row);
      }
      setTimeout(() => {
        if (cartItemsHost && typeof cartItemsHost.updateQuantity === 'function') {
          cartItemsHost.updateQuantity(index, 0, event);
        }
      }, 150);
    });
  }
}
customElements.define('cart-remove-button', CartRemoveButton);
(() => {
  if (document.getElementById('cart-remove-anim-css')) return;
  const style = document.createElement('style');
  style.id = 'cart-remove-anim-css';
  style.textContent = `
    tr.cart-item { will-change: height, opacity, margin, padding; }
  `;
  document.head.appendChild(style);
})();


class CartItems extends HTMLElement {
constructor() {
  super();
  this.lineItemStatusElement =
    document.getElementById('shopping-cart-line-item-status') ||
    document.getElementById('CartDrawer-LineItemStatus');
  const debouncedOnChange = debounce((event) => {
    this.onChange(event);
  }, ON_CHANGE_DEBOUNCE_TIMER);

  this.addEventListener('change', debouncedOnChange.bind(this));


}

  cartUpdateUnsubscriber = undefined;
  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      return this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  resetQuantityInput(id) {
  const input =
    this.querySelector(`#Quantity-${id}`) ||
    document.getElementById(`Drawer-quantity-${id}`);
  if (!input) {
    console.warn(`resetQuantityInput(): No quantity input exists for line ${id} — item was removed.`);
    return;
  }

  const prev = input.getAttribute('value');
  if (prev !== null) input.value = prev;
  this.isEnterPressed = false;
}


  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

validateQuantity(event) {
  const input = event.target;
  if (!input) return;

  const value = parseInt(input.value);
  const index = input.dataset.index;

  // ----------------------------------------
  // ✅ Allow value = 0 (means remove line)
  // ----------------------------------------
  if (value === 0) {
    this.updateQuantity(
      index,
      0,
      event,
      input.getAttribute('name'),
      input.dataset.quantityVariantId
    );
    return;
  }

  // ----------------------------------------
  // Shopify validation rules
  // ----------------------------------------
  let message = '';

  const min = parseInt(input.min || '1', 10);
  const max = parseInt(input.max || '9999', 10);
  const step = parseInt(input.step || '1', 10);

  if (value < min) {
    message = window.quickOrderListStrings.min_error.replace('[min]', min);
  } else if (value > max) {
    message = window.quickOrderListStrings.max_error.replace('[max]', max);
  } else if (value % step !== 0) {
    message = window.quickOrderListStrings.step_error.replace('[step]', step);
  }

  if (message) {
    this.setValidity(event, index, message);
  } else {
    input.setCustomValidity('');
    input.reportValidity();

    this.updateQuantity(
      index,
      value,
      event,
      input.getAttribute('name'),
      input.dataset.quantityVariantId
    );
  }
}



  onChange(event) {
    this.validateQuantity(event);
  }

  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      return fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      return fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      //{
      // id: 'cart-icon-bubble',
      // section: 'cart-icon-bubble',
       //selector: '.shopify-section',
      //},
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
      {
          id: 'cart-drawer',
          section: 'cart-drawer',
          selector: '.shopify-section'
        },
    ];
  }


 

  
updateQuantity(line, quantity, event, name, variantId) {
 traceCall("Step 1: updateQuantity() entered", {
  line,
  quantity,
  name,
  variantId,
  eventType: event?.type,
  eventTrusted: event?.isTrusted
});


  this.enableLoading(line);

  const body = JSON.stringify({
    line,
    quantity,
    sections: this.getSectionsToRender().map((section) => section.section),
    sections_url: window.location.pathname,
  });

  const eventTarget = event.currentTarget instanceof CartRemoveButton ? 'clear' : 'change';
traceCall("Step 2: Preparing fetch /cart/change.js", {
  body: JSON.parse(body)
});
  window.withCartLock(() =>
    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
  )
    .then((response) => response.text())
    .then((state) => {
      traceCall("Step 4: Parsing response");

      const parsedState = JSON.parse(state);
      console.log('[cart.js] Cart response parsed:', parsedState);

      CartPerformance.measure(`${eventTarget}:paint-updated-sections`, () => {
        const quantityElement =
          document.getElementById(`Quantity-${line}`) ||
          document.getElementById(`Drawer-quantity-${line}`);

        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          traceCall("Step 6: Shopify returned errors", parsedState.errors);

          console.warn('[cart.js] Errors in cart response:', parsedState.errors);

          if (quantityElement) {
            const prev = quantityElement.getAttribute('value');
            if (prev !== null) quantityElement.value = prev;
          } else {
            console.warn('[cart.js] quantityElement is null – item likely removed');
          }
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
          traceCall("Step 7: Patched section", { section: section.id });

          const target = document.getElementById(section.id);
          if (!target) {
            console.warn(`[cart.js] Target #${section.id} not found`);
            return;
          }

          const elementToReplace = target.querySelector(section.selector) || target;
          const newHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
          elementToReplace.innerHTML = newHTML;

          if (newHTML.includes('swiper') || newHTML.includes('cart-view')) {
            if (typeof reInitCartSwiper === 'function') reInitCartSwiper();
          }
        });
traceCall("Step 8: All sections patched");

        if (typeof window.applyInventoryGuards === 'function') {
          window.applyInventoryGuards(document);
        }

        const updatedValue =
          parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;

        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          message = typeof updatedValue === 'undefined'
            ? window.cartStrings.error
            : window.cartStrings.quantityError.replace('[quantity]', updatedValue);
        }

        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) ||
          document.getElementById(`CartDrawer-Item-${line}`);
        const fallbackTarget = document.querySelector('.cart-item__name');
        traceCall("Step 9: Re-applying focus logic");

        try {
          if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
            const input = lineItem.querySelector(`[name="${name}"]`);
            cartDrawerWrapper
              ? trapFocus(cartDrawerWrapper, input)
              : input.focus();
          } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
            const emptyWrapper = cartDrawerWrapper.querySelector('.drawer__inner-empty');
            const emptyLink = emptyWrapper ? emptyWrapper.querySelector('a') : null;
            if (emptyWrapper && emptyLink) {
              trapFocus(emptyWrapper, emptyLink);
            }
          } else if (fallbackTarget && cartDrawerWrapper) {
            trapFocus(cartDrawerWrapper, fallbackTarget);
          }
        } catch (trapErr) {
          traceCall("Step X: updateQuantity ERROR", { error: err });
          console.error('[cart.js] trapFocus failed:', trapErr);
        }
      });

      CartPerformance.measureFromEvent(`${eventTarget}:user-action`, event);
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId });
    })
    .catch((err) => {
      console.error('Cart update failed:', err);
      this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
      const errors =
        document.getElementById('cart-errors') ||
        document.getElementById('CartDrawer-CartErrors');
      if (errors) errors.textContent = window.cartStrings.error;
    })
    .finally(() => {
      traceCall("Step Final: updateQuantity finished");

      this.disableLoading(line);
    });
}




  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').textContent = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

// Drawer-scoped Swiper init
window.reInitCartSwiper = function reInitCartSwiper(source = 'unknown') {
  const el = document.querySelector('#CartDrawer .cart-view') || document.querySelector('cart-drawer .cart-view');
  if (!el) { console.warn('[swiper]', 'no .cart-view in drawer (from', source, ')'); return; }
  if (typeof window.Swiper !== 'function') { console.error('[swiper]', 'Swiper missing (from', source, ')'); return; }

  const wrapper = el.querySelector('.swiper-wrapper');
  const slides  = el.querySelectorAll('.swiper-slide');
  if (!wrapper || slides.length === 0) { console.warn('[swiper]', 'no wrapper/slides yet (from', source, ')'); return; }

  // destroy previous instance only on this node
  if (el.__swiper && !el.__swiper.destroyed && typeof el.__swiper.destroy === 'function') {
    try { el.__swiper.destroy(true, true); } catch (e) { console.warn('[swiper]', 'destroy failed', e); }
  }

  let inst;
  try {
    inst = new Swiper(el, {
      slidesPerView: 3,
      spaceBetween: 5,
      autoplay: { delay: 6000, disableOnInteraction: false },
      observer: true,
      observeParents: true,
      breakpoints: { 0: { slidesPerView: 2.5, spaceBetween: 5 }, 1200: { slidesPerView: 3, spaceBetween: 5 } },
      on: { init(sw) { } }
    });
  } catch (err) {
    console.error('[swiper]', 'init failed:', err, 'from', source);
    return;
  }

  el.__swiper = inst;
  requestAnimationFrame(() => inst.update());
};

// schedule after DOM paint (avoids racing your section swaps)
function scheduleSwiperInit(source = 'unknown') {
  requestAnimationFrame(() => requestAnimationFrame(() => window.reInitCartSwiper(source)));
}




customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
              .then(() => CartPerformance.measureFromEvent('note-update:user-action', event));
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}

// --- Inventory guards for +/- buttons (read DOM, cap at available) ---
(function () {
  function labelForInput(input) {
    return input.getAttribute('aria-label')
      || (input.closest('.cart-item')?.querySelector('.cart-item__name')?.textContent?.trim())
      || `Line ${input.dataset.index || '?'}`;
  }

  function readMaxFromDOM(input) {
    const managed = String(input.dataset.variantManaged || '').toLowerCase() === 'true';
    const policy  = (input.dataset.variantPolicy || '').toLowerCase(); // 'deny'|'continue'|''
    const rawMax  = input.dataset.variantMax;

    // If inventory is tracked AND policy is deny → cap by DOM max
    if (managed && policy !== 'continue') {
      const maxNum = parseInt(rawMax, 10);
      if (Number.isFinite(maxNum)) return Math.max(0, maxNum);
      // If managed but no number for some reason, be conservative and cap at current value
      const current = parseInt(input.value || input.getAttribute('value') || '1', 10) || 1;
      return Math.max(0, current);
    }

    // Not tracked or continue selling → unlimited
    return Infinity;
  }

  function toggleButtonsForInput(input) {
    const wrap  = input.closest('.quantity');
    if (!wrap) return;

    const minus = wrap.querySelector('button[name="minus"]');
    const plus  = wrap.querySelector('button[name="plus"]');

    const qty   = parseInt(input.value || input.getAttribute('value') || '1', 10) || 1;
    const max   = readMaxFromDOM(input);
    const vid   = input.getAttribute('data-quantity-variant-id') || input.dataset.quantityVariantId || 'N/A';
    const title = labelForInput(input);

    // Keep native [max] aligned (helps validity + our global click logic)
    if (Number.isFinite(max)) input.max = String(max);
    else input.removeAttribute('max');

    // ❗ DO NOT disable minus at 1 — we want a click to remove (our click handler sets 0)
    const disableMinus = (qty <= 0);
    const disablePlus  = (qty >= max);

    if (minus) minus.disabled = disableMinus;
    if (plus)  plus.disabled  = disablePlus;
  }

  async function guardOneInput(input) {
    toggleButtonsForInput(input);
  }

  // Public: call after any cart DOM update/replace
  window.applyInventoryGuards = function applyInventoryGuards(root = document) {
    const inputs = root.querySelectorAll('input.quantity__input[data-quantity-variant-id]');
    if (!inputs.length) return;
    inputs.forEach(guardOneInput);

    // Keep buttons responsive while the user types
    inputs.forEach((input) => {
      if (input.__hasGuardListener) return;
      input.addEventListener('input', () => guardOneInput(input), { passive: true });
      input.__hasGuardListener = true;
    });
  };

  // Run on load
  const runNow = () => window.applyInventoryGuards(document);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runNow);
  } else {
    runNow();
  }

  // Also watch for cart DOM swaps (drawer/main cart sections being replaced)
  const observer = new MutationObserver(() => window.applyInventoryGuards(document));
  observer.observe(document.documentElement, { subtree: true, childList: true });
})();


// Quick Add to Cart Product Cards
(function () {
  if (window.__BuyNowToDrawerBound) return;
  window.__DisableShopifyProductForm = true; 
  window.__BuyNowToDrawerBound = true;
  const LOG = (...a)=>console.log('[BUY-NOW→DRAWER]', ...a);

  // ---------- helpers ----------
  function addVariantJSON(payload) {
    LOG('POST /cart/add.js', payload);
    traceCall('CartStep 3: calling /cart/add.js', payload);
    return window.withCartLock(() =>
  fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    })).then(r => {
      if (!r.ok) return r.json().then(e => { throw e; });
      return r.json();
    });
  }

  // Build add.js payload from a product form (variant, qty, properties, selling_plan)
  function payloadFromForm(form) {
    const fd = new FormData(form);
    const id = (fd.get('id') || form.querySelector('input[name="id"]')?.value || '').toString();
    const quantity = parseInt(fd.get('quantity') || '1', 10) || 1;

    const properties = {};
    fd.forEach((val, key) => {
      if (key.startsWith('properties[') && key.endsWith(']')) {
        const prop = key.slice(11, -1);
        properties[prop] = val;
      }
    });

    const selling_plan = fd.get('selling_plan') || undefined;

    const payload = { id, quantity };
    if (selling_plan) payload.selling_plan = selling_plan;
    if (Object.keys(properties).length) payload.properties = properties;

    return payload;
  }

  // Quick Cart Refresh Drawer (empty-safe)
function refreshDrawer() {
  const base = (window.routes && window.routes.cart_url) ? window.routes.cart_url : '/cart';
  const url  = base + '?section_id=cart-drawer';
  LOG('GET', url);

  return fetch(url)
    .then(r => r.text())
    .then(htmlStr => {
      const doc = new DOMParser().parseFromString(htmlStr, 'text/html');

      // server truth
      const rowCount = doc.querySelectorAll('tbody tr.cart-item').length;
      traceCall('CartStep 6: server drawer rows', { rows: rowCount });

      const hasItemsNow = rowCount > 0;
      LOG('server has items?', hasItemsNow, 'rows=', rowCount);

      // replace items block
      const srcItems = doc.querySelector('cart-drawer-items');
      const dstItems = document.querySelector('cart-drawer-items');
      if (srcItems && dstItems) { dstItems.replaceWith(srcItems); LOG('replaced cart-drawer-items'); }

      // header
      const srcHeader = doc.querySelector('.drawer__header');
      const dstHeader = document.querySelector('.drawer__header');
      if (srcHeader && dstHeader) { dstHeader.replaceWith(srcHeader); LOG('replaced .drawer__header'); }

      // footer summary
      const srcFooter = doc.querySelector('.cart-drawer__footer');
      const dstFooter = document.querySelector('.cart-drawer__footer');
      const dstFooterWrap = document.querySelector('.drawer__footer');
      if (srcFooter) {
        if (dstFooter) { dstFooter.replaceWith(srcFooter); LOG('replaced .cart-drawer__footer'); }
        else if (dstFooterWrap) {
          const before = dstFooterWrap.querySelector('.cart__ctas') || null;
          dstFooterWrap.insertBefore(srcFooter, before);
          LOG('inserted .cart-drawer__footer');
        }
      } else if (dstFooter) {
        dstFooter.remove(); LOG('removed .cart-drawer__footer (server missing)');
      }

      // CTAs
        const srcCtas = doc.querySelector('.cart__ctas');
        const dstCtas = document.querySelector('.cart__ctas');
        const footerWrap =
          document.querySelector('#CartDrawer .drawer__footer, #CartDrawer .cart-drawer__footer, #CartDrawer .drawer__bottom') ||
          document.querySelector('cart-drawer .drawer__footer, cart-drawer .cart-drawer__footer, cart-drawer .drawer__bottom') ||
          document.querySelector('.drawer__footer, .cart-drawer__footer, .drawer__bottom');


        if (srcCtas) {
          const detached = srcCtas.cloneNode(true);
          if (dstCtas) {
            dstCtas.replaceWith(detached);
            console.log('[refreshDrawer]', 'replaced existing .cart__ctas');
          } else if (footerWrap) {
            footerWrap.appendChild(detached);
            console.log('[refreshDrawer]', 'inserted missing .cart__ctas');
          } else {
            const formEl = document.getElementById('CartDrawer-Form');
            if (formEl) formEl.appendChild(detached);
            console.log('[refreshDrawer]', 'fallback insert into #CartDrawer-Form');
          }
        } else if (dstCtas) {
          dstCtas.remove();
          console.log('[refreshDrawer]', 'removed .cart__ctas (server missing)');
        }


      // empty state
      const srcEmpty = doc.querySelector('.drawer__inner-empty');
      const dstEmpty = document.querySelector('.drawer__inner-empty');
      if (srcEmpty && !dstEmpty) {
        const parent = document.querySelector('#CartDrawer .drawer__inner');
        if (parent) { parent.appendChild(srcEmpty); LOG('inserted empty state'); }
      } else if (!srcEmpty && dstEmpty) {
        dstEmpty.remove(); LOG('removed empty state');
      }

      // is-empty flags
      const drawerEl = document.querySelector('cart-drawer');
      const drawerItemsEl = document.querySelector('cart-drawer-items');
      [drawerEl, drawerItemsEl].forEach(el => {
        if (!el) return;
        if (hasItemsNow) el.classList.remove('is-empty');
        else el.classList.add('is-empty');
      });
      LOG('is-empty forced =>', hasItemsNow ? 'NOT EMPTY' : 'EMPTY');

      // 👇 Apply inventory guards after the DOM is in place
      if (typeof window.applyInventoryGuards === 'function') {
        window.applyInventoryGuards(document);
      }

      // re-init upsell slider if available
      if (typeof window.reInitCartSwiper === 'function') {
        window.reInitCartSwiper();
        LOG('reInitCartSwiper() called');
      }
      guardDrawerQuickAddButtons();
    });
    traceCall('CartStep 7: refreshDrawer() complete');
}


  function openDrawer() {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) { LOG('no <cart-drawer> element found'); return; }
    try { drawer.open(); } catch(e) { LOG('drawer.open() error', e); }
    // ensure visibility rule
    document.head.insertAdjacentHTML('beforeend', '<style>.drawer.active{visibility:visible}</style>');
  }

  // ---------- intercept any product form submit ----------
  document.addEventListener('submit', function (e) {
    traceCall('CartStep 1: submit intercepted', { form: e.target });
    const form = e.target.closest('form[data-type="add-to-cart-form"]');
    if (!form) return;

    e.preventDefault();

    // ignore disabled
    const submitBtn = form.querySelector('[type="submit"][name="add"]');
    if (submitBtn?.disabled) return;

    submitBtn && (submitBtn.disabled = true, submitBtn.classList.add('is-loading'));

    const payload = payloadFromForm(form);
    traceCall('CartStep 2: payload built', payload);

    if (!payload.id) {
      console.error('[BUY-NOW→DRAWER] missing variant id');
      submitBtn && (submitBtn.disabled = false, submitBtn.classList.remove('is-loading'));
      return;
    }

    addVariantJSON(payload)
      .then(res => {
        LOG('add success', res);
        return refreshDrawer();
        traceCall('CartStep 4: add.js success', res);
        traceCall('CartStep 5: refreshDrawer() start');
      })
      .then(() => {
        LOG('drawer refreshed');
        openDrawer();
        // optional pub/sub for other theme parts
        try {
          if (typeof publish === 'function' && window.PUB_SUB_EVENTS?.cartUpdate) {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'buy-now' });
            LOG('published PUB_SUB cartUpdate');
          }
        } catch(_) {}
      })
      .catch(err => {
        console.error('[BUY-NOW→DRAWER] failed', err);
        alert((err && err.description) || 'Could not add to cart.');
      })
      .finally(() => {
        submitBtn && (submitBtn.disabled = false, submitBtn.classList.remove('is-loading'));
      });
  });

  LOG('ready');
})();


// =============== CART DRAWER QUICK ADD ===============

async function guardDrawerQuickAddButtons() {
  const btns = Array.from(
    document.querySelectorAll('#CartDrawer .quick-add-btn, cart-drawer .quick-add-btn')
  );
  if (!btns.length) return;

  const cart = await fetchCartJSON();
  const ids = Array.from(new Set(
    btns.map(b => parseInt(b.getAttribute('data-variant-id') || '0', 10)).filter(Boolean)
  ));

  const variants = await Promise.all(ids.map(id => fetchVariantJSON(id)));
  const vById = new Map();
  variants.forEach(v => { if (v) vById.set(v.id, v); });

  function allowedFor(id, requested) {
    const v = vById.get(Number(id));
    if (!v) return requested;

    const managed = !!v.inventory_management;
    const deny    = v.inventory_policy === 'deny';
    const max     = (managed && deny && Number.isFinite(v.inventory_quantity))
      ? Math.max(0, v.inventory_quantity)
      : Infinity;
    const inCart = (cart.items || []).reduce((sum, it) =>
      sum + (String(it.variant_id) === String(id) ? it.quantity : 0), 0);
    const remaining = Number.isFinite(max) ? Math.max(0, max - inCart) : Infinity;
    return Number.isFinite(remaining) ? Math.min(requested, remaining) : requested;
  }

  btns.forEach(btn => {
    const id  = parseInt(btn.getAttribute('data-variant-id') || '0', 10);
    const req = parseInt(btn.getAttribute('data-quantity') || '1', 10) || 1;
    const allowed = allowedFor(id, req);

    if (!allowed || allowed <= 0) {
      btn.disabled = true;
      btn.classList.add('is-disabled');
      btn.setAttribute('aria-disabled', 'true');
    } else {
      btn.disabled = false;
      btn.classList.remove('is-disabled');
      btn.removeAttribute('aria-disabled');
    }
  });
}

// --- Quick-Add Inventory Preflight (shared) ---------------------------------
const QA_INV_CACHE = {
  variant: new Map(),
  cart:    null,
  cartAt:  0
};

async function fetchVariantJSON(variantId){
  if (QA_INV_CACHE.variant.has(variantId)) return QA_INV_CACHE.variant.get(variantId);
  const r = await fetch(`/variants/${variantId}.json`, { credentials:'same-origin' });
  if (!r.ok) return null;
  const j = await r.json();
  QA_INV_CACHE.variant.set(variantId, j?.variant || null);
  return j?.variant || null;
}

async function fetchCartJSON(force=false){
  const now = Date.now();
  if (!force && QA_INV_CACHE.cart && (now - QA_INV_CACHE.cartAt) < 2000) return QA_INV_CACHE.cart;
  const r = await fetch('/cart.js', { credentials:'same-origin' });
  if (!r.ok) return { items: [] };
  const j = await r.json();
  QA_INV_CACHE.cart  = j;
  QA_INV_CACHE.cartAt = now;
  return j;
}

function computeVariantMax(variant){
  if (!variant) return Infinity;
  const managed = !!variant.inventory_management;
  const deny    = (variant.inventory_policy === 'deny');
  const qty     = Number.isFinite(variant.inventory_quantity) ? Math.max(0, variant.inventory_quantity) : 0;
  return (managed && deny) ? qty : Infinity;
}

async function preflightAdd(variantId, requestedQty){
  const [variant, cart] = await Promise.all([ fetchVariantJSON(variantId), fetchCartJSON() ]);
  const max = computeVariantMax(variant);
  const inCart = (cart.items || []).reduce((sum, it) =>
    sum + (String(it.variant_id) === String(variantId) ? it.quantity : 0), 0
  );
  const remaining = Number.isFinite(max) ? Math.max(0, max - inCart) : Infinity;
  const allowed   = Number.isFinite(remaining) ? Math.min(requestedQty, remaining) : requestedQty;
  return { allowed, remaining, max, inCart };
}

function afterBlockedAdd(btn){
  if (btn) {
    btn.disabled = true;
    btn.classList.add('is-disabled');
    setTimeout(()=>{ btn.disabled = false; btn.classList.remove('is-disabled'); }, 900);
  }
}

// =============== Drawer refresh (robust/empty-safe) ===============
function refreshDrawer() {
  traceCall('CartStep 5: refreshDrawer() start');
  const base = (window.routes && window.routes.cart_url) ? window.routes.cart_url : '/cart';
  const url  = base + '?section_id=cart-drawer';

  // small helper: replace/insert/remove selector
  function syncBlock(doc, selector, opts = {}) {
    const src = doc.querySelector(selector);
    const dst = document.querySelector(selector);
    if (src && dst) {
      dst.replaceWith(src);
      return true;
    }
    if (src && !dst && opts.insertInto) {
      const parent = document.querySelector(opts.insertInto);
      if (parent) {
        const before = opts.before ? parent.querySelector(opts.before) : null;
        parent.insertBefore(src, before || null);
        return true;
      }
    }
    if (!src && dst && opts.removeIfMissing !== false) {
      dst.remove();
      return true;
    }
    return false;
  }

  return fetch(url, { credentials: 'same-origin', cache: 'no-store' })
    .then(r => r.text())
    .then(htmlStr => {
      const doc = new DOMParser().parseFromString(htmlStr, 'text/html');
      const hasItemsNow = !!doc.querySelector('tbody tr.cart-item');
      const dstForm      = document.querySelector('#CartDrawer-Form');
      const srcItemsWrap = doc.querySelector('#CartDrawer-Form .js-contents') || doc.querySelector('cart-drawer-items .js-contents');
      const dstItemsWrap = dstForm?.querySelector('.js-contents');

      if (dstForm && srcItemsWrap && dstItemsWrap) {
        dstItemsWrap.innerHTML = srcItemsWrap.innerHTML;
      } else {
        syncBlock(doc, 'cart-drawer-items');
      }
      syncBlock(doc, '.drawer__header');
      syncBlock(doc, '.cart-drawer__footer', {
        insertInto: '.drawer__footer',
        before: '.cart__ctas'
      });
      const srcCtas = doc.querySelector('.cart__ctas');
      const dstCtas = document.querySelector('.cart__ctas');
      const footerWrap =
        document.querySelector('#CartDrawer .drawer__footer, #CartDrawer .cart-drawer__footer, #CartDrawer .drawer__bottom') ||
        document.querySelector('cart-drawer .drawer__footer, cart-drawer .cart-drawer__footer, cart-drawer .drawer__bottom') ||
        document.querySelector('.drawer__footer, .cart-drawer__footer, .drawer__bottom');

            if (srcCtas) {
        const detached = srcCtas.cloneNode(true);
        if (dstCtas) {
          dstCtas.replaceWith(detached);
          console.log('[refreshDrawer]', 'replaced existing .cart__ctas');
        } else if (footerWrap) {
          footerWrap.appendChild(detached);
          console.log('[refreshDrawer]', 'inserted missing .cart__ctas');
        } else {
          const formEl = document.getElementById('CartDrawer-Form');
          if (formEl) formEl.appendChild(detached);
          console.log('[refreshDrawer]', 'fallback insert into #CartDrawer-Form');
        }
      } else if (dstCtas) {
        dstCtas.remove();
        console.log('[refreshDrawer]', 'removed .cart__ctas (server missing)');
      }

      // Empty-state block
      const srcEmpty = doc.querySelector('.drawer__inner-empty');
      const dstEmpty = document.querySelector('.drawer__inner-empty');
      if (srcEmpty && !dstEmpty) {
        const parent = document.querySelector('#CartDrawer .drawer__inner') || document.querySelector('cart-drawer .drawer__inner');
        if (parent) parent.appendChild(srcEmpty);
      } else if (!srcEmpty && dstEmpty) {
        dstEmpty.remove();
      } else if (srcEmpty && dstEmpty) {
        dstEmpty.replaceWith(srcEmpty);
      }

      const drawerEl = document.querySelector('cart-drawer');
      const drawerItemsEl = document.querySelector('cart-drawer-items');
      [drawerEl, drawerItemsEl].forEach(el => {
        if (!el) return;
        if (hasItemsNow) el.classList.remove('is-empty');
        else el.classList.add('is-empty');
      });

      if (typeof window.applyInventoryGuards === 'function') window.applyInventoryGuards(document);
      if (typeof window.reInitCartSwiper === 'function') window.reInitCartSwiper();
      guardDrawerQuickAddButtons();
    });
}

// =============== Quick Add to Cart Upsells ===============
(function () {
  if (window.__drawerQuickAddBoundV4) return;
  window.__drawerQuickAddBoundV4 = true;

  // capture link clicks on slides/cards, let bubble continue
  document.addEventListener('click', function (ev) {
    const btn = ev.target.closest('.quick-add-btn');
    if (!btn) return;
    if (ev.target.closest('a, [role="link"], .card-permalink, .swiper-slide')) {
      ev.preventDefault();
    }
  }, true);

  async function addVariant(variantId, qty, props, btnForUX){
    const wantQty = parseInt(qty || '1', 10) || 1;
    const { allowed } = await preflightAdd(String(variantId), wantQty);

    if (allowed <= 0) {
      afterBlockedAdd(btnForUX);
      return { blocked: true, reason: 'max-reached' };
    }

    const payload = { id: variantId, quantity: allowed };
    if (props && Object.keys(props).length) payload.properties = props;

    const r = await window.withCartLock(() =>
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify(payload),
    credentials: 'same-origin'
  })
);


    if (!r.ok) throw await r.json();
    return r.json();
  }

  function syncBlock(doc, selector, opts = {}) {
    const src = doc.querySelector(selector);
    const dst = document.querySelector(selector);
    if (src && dst) { dst.replaceWith(src); return true; }
    if (src && !dst && opts.insertInto) {
      const parent = document.querySelector(opts.insertInto);
      if (parent) {
        const before = opts.before ? parent.querySelector(opts.before) : null;
        parent.insertBefore(src, before || null);
        return true;
      }
    }
    if (!src && dst && opts.removeIfMissing !== false) { dst.remove(); return true; }
    return false;
  }

  function refreshDrawerInternal() {
    const base = (window.routes && window.routes.cart_url) ? window.routes.cart_url : '/cart';
    const url  = base + '?section_id=cart-drawer';

    return fetch(url, { credentials: 'same-origin', cache: 'no-store' })
      .then(r => r.text())
      .then(htmlStr => {
        const doc = new DOMParser().parseFromString(htmlStr, 'text/html');

        const rowCount = doc.querySelectorAll('tbody tr.cart-item').length;
        const hasItemsNow = rowCount > 0;
        syncBlock(doc, 'cart-drawer-items');
        syncBlock(doc, '.drawer__header');
        syncBlock(doc, '.cart-drawer__footer', {
          insertInto: '.drawer__footer',
          before: '.cart__ctas'
        });
        const srcCtas = doc.querySelector('.cart__ctas');
        const dstCtas = document.querySelector('.cart__ctas');
        const footerWrap =
  document.querySelector('#CartDrawer .drawer__footer, #CartDrawer .cart-drawer__footer, #CartDrawer .drawer__bottom') ||
  document.querySelector('cart-drawer .drawer__footer, cart-drawer .cart-drawer__footer, cart-drawer .drawer__bottom') ||
  document.querySelector('.drawer__footer, .cart-drawer__footer, .drawer__bottom');

        if (srcCtas) {
          if (dstCtas) {
            dstCtas.replaceWith(srcCtas);
          } else if (footerWrap) {
            const freshFooter = document.querySelector('.cart-drawer__footer');
            if (freshFooter && freshFooter.parentElement === footerWrap) {
              freshFooter.insertAdjacentElement('afterend', srcCtas);
            } else {
              footerWrap.appendChild(srcCtas);
            }
          } else {
            const formEl = document.getElementById('CartDrawer-Form');
            if (formEl) formEl.appendChild(srcCtas);
          }
        } else if (dstCtas) {
          dstCtas.remove();
        }

        const srcEmpty = doc.querySelector('.drawer__inner-empty');
        const dstEmpty = document.querySelector('.drawer__inner-empty');
        if (srcEmpty && !dstEmpty) {
          const parent = document.querySelector('#CartDrawer .drawer__inner') || document.querySelector('cart-drawer .drawer__inner');
          if (parent) parent.appendChild(srcEmpty);
        } else if (!srcEmpty && dstEmpty) {
          dstEmpty.remove();
        } else if (srcEmpty && dstEmpty) {
          dstEmpty.replaceWith(srcEmpty);
        }
        const drawerEl = document.querySelector('cart-drawer');
        const drawerItemsEl = document.querySelector('cart-drawer-items');
        [drawerEl, drawerItemsEl].forEach(el => {
          if (!el) return;
          if (hasItemsNow) el.classList.remove('is-empty');
          else el.classList.add('is-empty');
        });

        if (typeof window.reInitCartSwiper === 'function') window.reInitCartSwiper();
        guardDrawerQuickAddButtons();
      });
  }

 document.addEventListener('click', async function (e) {
  const btn = e.target.closest('.quick-add-btn');
  if (!btn) return;
  e.preventDefault();
  e.stopPropagation();
  if (!btn.getAttribute('type')) btn.setAttribute('type', 'button');
  const idStr = btn.getAttribute('data-variant-id');
  const id    = idStr ? parseInt(idStr, 10) : NaN;
  const req   = parseInt(btn.getAttribute('data-quantity') || '1', 10) || 1;
  if (!id || isNaN(id)) return;
  let allowed = req;
  try { allowed = (await preflightAdd(id, req)).allowed; } catch (_) {}
  if (!allowed || allowed <= 0) { afterBlockedAdd(btn); return; }
  const labelEl = btn.querySelector('[data-label]') || btn.querySelector('.label') || btn;
  const prevTxt = (labelEl.textContent || '').trim();
  labelEl.textContent = 'Adding…';
  btn.disabled = true;
  btn.classList.add('is-loading');
  addVariant(id, allowed, null, btn)
    .then(() => refreshDrawer())   
    .then(() => {setTimeout(() => updateCartCountBubble(), 80);document.querySelector('cart-drawer')?.open?.();})

    .catch(() => {})
    .finally(() => {
      // restore label + state
      labelEl.textContent = prevTxt || 'Add to Cart';
      btn.disabled = false;
      btn.classList.remove('is-loading');
    });
});


  const style = document.createElement('style');
  style.textContent = `
    .drawer.active { visibility: visible; }
    cart-drawer .cart-drawer__collection .card-permalink { pointer-events: none; }
    .quick-add-btn.is-loading { opacity: .6; pointer-events: none; }
  `;
  document.head.appendChild(style);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => guardDrawerQuickAddButtons(), { once: true });
  } else {
    guardDrawerQuickAddButtons();
  }
})();

//=============== GRID ADD TO CART ===============
(function () {
  // --- Money helper ---
  function money(cents) {
    const fmt = (window.SHOP && window.SHOP.moneyFormat) || "${{amount}}";
    try {
      return Shopify.formatMoney(cents, fmt);
    } catch (_) {
      const cur = (window.SHOP && window.SHOP.currency) || "USD";
      return (cents / 100).toLocaleString(undefined, { style: "currency", currency: cur });
    }
  }

  function routesBase() {
    return (window.routes && window.routes.cart_url) ? window.routes.cart_url : '/cart';
  }
  function publishCartUpdate() {
    try {
      if (typeof publish === 'function' && window.PUB_SUB_EVENTS?.cartUpdate)
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'quick-add' });
    } catch (_) {}
  }

  // --- Normalizers / helpers (define ONCE globally) ---
  function normVal(v) {
    if (v == null) return '';
    if (typeof v === 'string' || typeof v === 'number' || typeof v === 'boolean') return String(v);
    if (typeof v === 'object') {
      if ('value' in v) return String(v.value);
      if ('name' in v) return String(v.name);
      try { return JSON.stringify(v); } catch { return String(v); }
    }
    return String(v);
  }
  function isDefaultTitle(s) {
    return typeof s === 'string' && /^\s*default\s*title\s*$/i.test(s);
  }
  function prettyVal(v) {
    const s = normVal(v).trim();
    return /^default\s*title$/i.test(s) ? 'One Size' : s;
  }
  function hasRealOptions(p) {
    if (Array.isArray(p.options) && p.options.length === 1 && String(p.options[0]).toLowerCase() === 'title') {
      const allDefault = Array.isArray(p.variants) && p.variants.length &&
        p.variants.every(v => isDefaultTitle(v?.options?.[0]));
      if (allDefault) return false;
    }
    return true;
  }
  function cssEscapeSafe(str) {
    if (window.CSS && typeof window.CSS.escape === 'function') return window.CSS.escape(String(str));
    // minimal fallback
    return String(str).replace(/[^a-zA-Z0-9_\-]/g, '\\$&');
  }
  function escAttr(s) { return normVal(s).replace(/"/g, '&quot;'); }
  function escHtml(s) {
    return normVal(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');
  }
  function labelForOptionName(name) {
    const raw = normVal(name).trim();
    if (!raw || /^title$/i.test(raw) || /^default\s*title$/i.test(raw)) return 'Size';
    return raw;
  }

  // =============== Grid ATC Drawer refresh (empty-safe) ===============
  function refreshDrawer() {
    const base = routesBase();
    const url  = base + '?section_id=cart-drawer';

    return fetch(url, { credentials: 'same-origin' })
      .then(r => r.text())
      .then(html => {
        const doc = new DOMParser().parseFromString(html, 'text/html');

        // 1) Replace JUST the items contents (preserve existing <form> and wrapper)
        const srcItems = doc.querySelector('#CartDrawer-Form .js-contents') || doc.querySelector('#CartDrawer-CartItems');
        const dstItems = document.querySelector('#CartDrawer-Form .js-contents') || document.querySelector('#CartDrawer-CartItems');
        if (srcItems && dstItems) dstItems.innerHTML = srcItems.innerHTML;

        // 2) Header (title/count/free shipping progress)
        const srcHeader = doc.querySelector('.drawer__header');
        const dstHeader = document.querySelector('.drawer__header');
        if (srcHeader && dstHeader) dstHeader.replaceWith(srcHeader);

        // 3) Footer summary
        const srcFooter = doc.querySelector('.cart-drawer__footer');
        const dstFooter = document.querySelector('.cart-drawer__footer');
        const dstFooterWrap = document.querySelector('.drawer__footer');
        if (srcFooter) {
          if (dstFooter) dstFooter.replaceWith(srcFooter);
          else if (dstFooterWrap) {
            const before = dstFooterWrap.querySelector('.cart__ctas') || null;
            dstFooterWrap.insertBefore(srcFooter, before);
          }
        } else if (dstFooter) {
          dstFooter.remove();
        }

        // 4) CTAs
        const srcCtas = doc.querySelector('.cart__ctas');
        const dstCtas = document.querySelector('.cart__ctas');
        const footerWrap =
          document.querySelector('#CartDrawer .drawer__footer, #CartDrawer .cart-drawer__footer, #CartDrawer .drawer__bottom') ||
          document.querySelector('cart-drawer .drawer__footer, cart-drawer .cart-drawer__footer, cart-drawer .drawer__bottom') ||
          document.querySelector('.drawer__footer, .cart-drawer__footer, .drawer__bottom');

              if (srcCtas) {
          const detached = srcCtas.cloneNode(true);
          if (dstCtas) {
            dstCtas.replaceWith(detached);
            console.log('[refreshDrawer]', 'replaced existing .cart__ctas');
          } else if (footerWrap) {
            footerWrap.appendChild(detached);
            console.log('[refreshDrawer]', 'inserted missing .cart__ctas');
          } else {
            const formEl = document.getElementById('CartDrawer-Form');
            if (formEl) formEl.appendChild(detached);
            console.log('[refreshDrawer]', 'fallback insert into #CartDrawer-Form');
          }
        } else if (dstCtas) {
          dstCtas.remove();
          console.log('[refreshDrawer]', 'removed .cart__ctas (server missing)');
        }


        // 5) Empty state show/hide based on server
        const srcEmpty = doc.querySelector('.drawer__inner-empty');
        const dstEmpty = document.querySelector('.drawer__inner-empty');
        if (srcEmpty && !dstEmpty) {
          const parent = document.querySelector('#CartDrawer .drawer__inner');
          if (parent) parent.appendChild(srcEmpty);
        } else if (!srcEmpty && dstEmpty) {
          dstEmpty.remove();
        }

        // 6) Force is-empty flags
        const hasItemsNow = !!doc.querySelector('tbody tr.cart-item');
        ['cart-drawer', 'cart-drawer-items'].forEach(sel => {
          const el = document.querySelector(sel);
          if (el) el.classList.toggle('is-empty', !hasItemsNow);
        });

        // 7) Re-init any drawer sliders/observers
        if (typeof window.reInitCartSwiper === 'function') window.reInitCartSwiper();
      });
  }

  function openDrawer() {
    const d = document.querySelector('cart-drawer');
    if (d && typeof d.open === 'function') { try { d.open(); return; } catch (_) {} }
    const crude = document.getElementById('CartDrawer');
    if (crude) crude.classList.add('active');
  }

  // --- Inject shimmer CSS once ---
  (function injectCpqaStyles() {
    if (document.getElementById('cpqa-skeleton-styles')) return;
    const css = `
#cpqa .cp__image{position:relative;min-height:220px;aspect-ratio:1/1;overflow:hidden}
#cpqa .cp__image.loading::before{content:"";position:absolute;inset:0;background:linear-gradient(90deg,rgba(0,0,0,.06) 25%,rgba(0,0,0,.12) 37%,rgba(0,0,0,.06) 63%);animation:cpqa-shimmer 1.2s linear infinite;background-size:400% 100%;border-radius:8px}
@keyframes cpqa-shimmer{0%{background-position:100% 0}100%{background-position:-100% 0}}
#cpqa .cp__image img{display:block;width:100%;height:100%;object-fit:cover;opacity:0;transition:opacity .25s ease}
#cpqa .cp__image img.is-ready{opacity:1}
    `.trim();
    const tag = document.createElement('style');
    tag.id = 'cpqa-skeleton-styles';
    tag.textContent = css;
    document.head.appendChild(tag);
  })();

  // =============== Modal Quick Add (#cpqa, once globally) ===============
  (function () {
    const shell = document.getElementById('cpqa');
    if (!shell) return; // no modal exists, skip the whole block

    const htmlEl = document.documentElement;
    const els = {
      imgWrap: shell.querySelector('.cp__image'),
      vendor:  shell.querySelector('.vendor'),
      title:   shell.querySelector('.cp__name'),
      price:   shell.querySelector('[data-price]'),
      compare: shell.querySelector('[data-compare-at]'),
      form:    shell.querySelector('.cp-form'),
      opts:    shell.querySelector('.options'),
      varId:   shell.querySelector('[data-qa-id]'),
      addBtn:  shell.querySelector('[data-add-btn]'),
      err:     shell.querySelector('[data-error]'),
      ok:      shell.querySelector('[data-success]'),
      close:   shell.querySelector('.cp-close')
    };

    let _product = null;

    function openShell() {
      shell.hidden = false;
      shell.setAttribute('aria-hidden', 'false');
      htmlEl.classList.add('qa-active');
    }
    function closeShell() {
      shell.hidden = true;
      shell.setAttribute('aria-hidden', 'true');
      htmlEl.classList.remove('qa-active');
    }
    function hideMsg() { if (els.err) els.err.style.display = 'none'; if (els.ok) els.ok.style.display = 'none'; }
    function showErr(m) { if (!els.err) return; els.err.textContent = m; els.err.style.display = ''; if (els.ok) els.ok.style.display = 'none'; }
    function showOk() { if (!els.ok) return; els.ok.style.display = ''; if (els.err) els.err.style.display = 'none'; }

    // Build a normalized value set for an option index
    function uniqueValuesForOption(product, idx) {
      const set = new Set();
      (product.variants || []).forEach(v => set.add(normVal(v.options?.[idx])));
      return Array.from(set);
    }
    function variantForOptions(product, chosen) {
      return product.variants.find(v =>
        v.options.every((o, i) => normVal(o) === normVal(chosen[i]))
      );
    }
    function availableForValue(product, chosen, idx, val) {
      const test = chosen.slice();
      test[idx] = normVal(val);
      const v = variantForOptions(product, test);
      return v ? !!v.available : false;
    }
    function currentChosenFromRadios() {
      return Array.from(els.opts.querySelectorAll('[data-radiogroup]')).map(g => {
        const c = g.querySelector('input[type="radio"]:checked'); return c ? c.value : '';
      });
    }

    // --- render options as buttons ---
    function renderOptionsAsButtons(product) {
      if (!els.opts) return;
      els.opts.innerHTML = '';
      if (!hasRealOptions(product)) return;

      product.options.forEach((optName, i) => {
        const values  = uniqueValuesForOption(product, i);
        const groupId = 'cpqa-opt-' + i;

        const optLabel = labelForOptionName(optName);
        const wrap = document.createElement('div');
        wrap.className = 'cp-option-group';
        wrap.setAttribute('data-radiogroup', String(i));

        const buttonsHtml = values.map((raw, idx) => {
          const rawVal = normVal(raw);
          const show   = prettyVal(rawVal);
          const id     = groupId + '-' + idx;
          return (
            '<div class="variant-wrapper">' +
              '<input type="radio" ' +
                'id="' + escAttr(id) + '" ' +
                'name="' + escAttr(groupId) + '" ' +
                'value="' + escAttr(rawVal) + '" ' +
                'class="cp-variant-radio" data-index="' + i + '">' +
              '<label for="' + escAttr(id) + '" class="cp-variant-btn">' + escHtml(show) + '</label>' +
            '</div>'
          );
        }).join('');

        wrap.innerHTML =
          '<div class="cp-option-label">' + escHtml(optLabel) + '</div>' +
          '<div class="cp-option-buttons margin-t-10 margin-b-10" role="radiogroup" aria-label="' + escAttr(optLabel) + '">' +
            buttonsHtml +
          '</div>';

        els.opts.appendChild(wrap);
      });
    }

    // --- skeleton + decode + fade-in ---
    function setModalImage(url, altText) {
      const wrap = els.imgWrap;
      if (!wrap) return;

      // start skeleton
      wrap.classList.add('loading');
      wrap.setAttribute('aria-busy', 'true');

      if (!url) {
        wrap.innerHTML = '';
        wrap.classList.remove('loading');
        wrap.removeAttribute('aria-busy');
        return;
      }

      const img = new Image();
      img.decoding = 'async';
      img.loading = 'eager';
      img.alt = (altText || '').replace(/"/g, '\"');

      // Shopify CDN sized rendition (tweak 360x if you want larger/smaller)
      const sized = url.replace(/(\.(jpg|jpeg|png|gif|webp))(?:\?.*)?$/i, '_360x$1');
      img.src = sized;

      const finalize = () => {
        wrap.innerHTML = '';
        wrap.appendChild(img);
        requestAnimationFrame(() => img.classList.add('is-ready'));
        wrap.classList.remove('loading');
        wrap.removeAttribute('aria-busy');
      };
      const fail = () => {
        console.warn('[CPQA] image failed to load', url);
        wrap.innerHTML = '';
        wrap.classList.remove('loading');
        wrap.removeAttribute('aria-busy');
      };

      if (img.decode) {
        img.decode().then(finalize).catch(() => {
          img.onload = finalize; img.onerror = fail;
        });
      } else {
        img.onload = finalize; img.onerror = fail;
      }
    }

    function applyVariant(v) {
      if (!els.varId || !els.addBtn || !els.price) return;
      if (!v) {
        els.varId.value = '';
        els.addBtn.disabled = true;
        els.price.textContent = '';
        if (els.compare) els.compare.style.display = 'none';
        return;
      }
      els.varId.value = v.id;
      els.addBtn.disabled = !v.available;
      els.price.textContent = money(v.price);
      if (els.compare) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          els.compare.textContent = money(v.compare_at_price);
          els.compare.style.display = '';
        } else {
          els.compare.textContent = '';
          els.compare.style.display = 'none';
        }
      }
    }

    function updateDisabledStates() {
      if (!_product || !hasRealOptions(_product) || !els.opts) return;
      const chosen = currentChosenFromRadios();
      _product.options.forEach((_, i) => {
        const group = els.opts.querySelector(`[data-radiogroup="${i}"]`); if (!group) return;
        group.querySelectorAll('input.cp-variant-radio').forEach(input => {
          const ok = availableForValue(_product, chosen, i, input.value);
          input.disabled = !ok;
          input.classList.toggle('disabled', !ok);
          const lab = group.querySelector(`label[for="${escAttr(input.id)}"]`) || group.querySelector(`label[for="${input.id}"]`);
          if (lab) lab.classList.toggle('disabled', !ok);
        });
      });
    }

    function primeSelection(product) {
      const v0 = product.variants.find(v => v.available) || product.variants[0];

      if (hasRealOptions(product) && els.opts) {
        product.options.forEach((_, i) => {
          const group = els.opts.querySelector(`[data-radiogroup="${i}"]`);
          if (!group) return;
          const val = normVal(v0.options[i]);
          const selector = `input[value="${cssEscapeSafe(String(val))}"]`;
          const input = group.querySelector(selector);
          if (input) {
            input.checked = true;
            const lab = group.querySelector(`label[for="${escAttr(input.id)}"]`) || group.querySelector(`label[for="${input.id}"]`);
            if (lab) lab.classList.add('active');
          }
        });
        updateDisabledStates();
      } else if (els.opts) {
        els.opts.innerHTML = '';
      }

      applyVariant(v0);
    }

    function bindRadioChanges() {
      if (!els.opts) return;
      els.opts.addEventListener('change', (e) => {
        const input = e.target && e.target.closest && e.target.closest('input.cp-variant-radio'); if (!input) return;
        hideMsg();
        const group = input.closest('[data-radiogroup]');
        if (group) {
          group.querySelectorAll('.cp-variant-btn').forEach(l => l.classList.remove('active'));
          const lab = group.querySelector(`label[for="${escAttr(input.id)}"]`) || group.querySelector(`label[for="${input.id}"]`);
          if (lab) lab.classList.add('active');
        }
        updateDisabledStates();
        const chosen = currentChosenFromRadios();
        const v = variantForOptions(_product, chosen) || _product.variants[0];
        applyVariant(v);
      });
    }

    // --- FULL loadProduct with skeleton image handling ---
    async function loadProduct(handle) {
      hideMsg();
      if (els.addBtn) { els.addBtn.disabled = true; els.addBtn.textContent = 'Loading…'; }

      try {
        const r = await fetch(`/products/${encodeURIComponent(handle)}.js`, { credentials: 'same-origin' });
        if (!r.ok) throw new Error('Failed to load product');
        const p = await r.json(); _product = p;

        // Image (skeleton shimmer -> decode -> fade-in)
        setModalImage((p.images && p.images[0]) || '', p.title || '');

        // Meta
        if (els.vendor) els.vendor.textContent = p.vendor || '';
        if (els.title)  els.title.textContent  = p.title || '';

        // Options UI
        if (hasRealOptions(p)) {
          renderOptionsAsButtons(p);
          bindRadioChanges();
        } else if (els.opts) {
          els.opts.innerHTML = '';
        }

        // Variant + prices
        primeSelection(p);

        // Ready UI + open
        if (els.addBtn) { els.addBtn.textContent = 'Add to Cart'; els.addBtn.disabled = false; }
        openShell();
      } catch (err) {
        console.error('[CPQA] loadProduct error:', err);
        showErr('Unable to load product.');
        if (els.addBtn) { els.addBtn.textContent = 'Add to Cart'; els.addBtn.disabled = false; }
      }
    }

    // --- Form submit ---
    if (els.form) {
      els.form.addEventListener('submit', function (e) {
        e.preventDefault();
        hideMsg();
        const id = els.varId && els.varId.value;
        if (!id) { showErr('Please select an option.'); return; }
        const prev = els.addBtn ? els.addBtn.textContent : 'Adding…';
        if (els.addBtn) { els.addBtn.disabled = true; els.addBtn.textContent = 'Adding…'; }

        window.withCartLock(() =>
  fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id, quantity: 1 }),
          credentials: 'same-origin'
        }))
          .then(r => r.ok ? r.json() : r.json().then(j => { throw j; }))
          .then(() => refreshDrawer())
          .then(() => { publishCartUpdate(); updateCartCountBubble(); openDrawer(); showOk(); if (els.addBtn) els.addBtn.textContent = 'Added ✓'; })
          .catch(err => { showErr((err && err.description) || 'Could not add to cart.'); if (els.addBtn) els.addBtn.textContent = prev; })
          .finally(() => { if (els.addBtn) els.addBtn.disabled = false; setTimeout(closeShell, 300); });
      });
    }

    // --- Open via any .qa-btn[data-handle] ---
    document.addEventListener('click', function (e) {
      const btn = e.target.closest && e.target.closest('.qa-btn[data-handle]');
      if (!btn) return;
      e.preventDefault();
      loadProduct(btn.getAttribute('data-handle'));
    });

    // --- Close wiring ---
    if (els.close) els.close.addEventListener('click', closeShell);
    shell.addEventListener('click', (e) => { if (e.target === shell) closeShell(); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeShell(); });
  })();

  // =============== Direct Quick Add (buttons with data-qa-id) ===============
  (function () {
    if (window.__drawerQuickAddDirectV1) return; window.__drawerQuickAddDirectV1 = true;

    document.addEventListener('click', function (ev) {
      const btn = ev.target.closest && ev.target.closest('.qa-btn[data-qa-id]');
      if (!btn) return;
      if (ev.target.closest('a, [role="link"], .card-permalink, .swiper-slide')) ev.preventDefault();
    }, true);

    document.addEventListener('click', function (e) {
      const btn = e.target.closest && e.target.closest('.qa-btn[data-qa-id]');
      if (!btn) return;
      e.preventDefault(); e.stopPropagation();
      if (!btn.getAttribute('type')) btn.setAttribute('type', 'button');
      const id = btn.getAttribute('data-qa-id');
      const qty = parseInt(btn.getAttribute('data-quantity') || '1', 10);
      if (!id) return;

      btn.disabled = true; btn.classList.add('is-loading');
      window.withCartLock(() =>
  fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id, quantity: qty }),
        credentials: 'same-origin'
      }))
        .then(r => r.ok ? r.json() : r.json().then(j => { throw j; }))
        .then(() => refreshDrawer())
        .then(() => { publishCartUpdate(); updateCartCountBubble(); openDrawer(); })
        .catch(err => { console.error('[DRAWER-QUICK-ADD] failed', err); alert((err && err.description) || 'Could not add to cart.'); })
        .finally(() => { btn.disabled = false; btn.classList.remove('is-loading'); });
    });
  })();
})();





// =============== Hover/Focus quick-add button highlight on product cards ===============
(function () {
  function gridItem(el) { return el && (el.closest ? el.closest('.grid__item') : null); }
  function setActive(item, on) {
    if (!item) return;
    const btn = item.querySelector('.qa-btn');
    if (btn) btn.classList.toggle('active', !!on);
  }
  document.addEventListener('mouseover', function (e) {
    const to = gridItem(e.target);
    const from = gridItem(e.relatedTarget);
    if (to && to !== from) setActive(to, true);
  });
  document.addEventListener('mouseout', function (e) {
    const from = gridItem(e.target);
    const to = gridItem(e.relatedTarget);
    if (from && from !== to) setActive(from, false);
  });
  document.addEventListener('focusin', function (e) {
    const item = gridItem(e.target);
    if (item) setActive(item, true);
  });
  document.addEventListener('focusout', function (e) {
    const item = gridItem(e.target);
    const next = gridItem(e.relatedTarget);
    if (item && item !== next) setActive(item, false);
  });
  document.addEventListener('touchstart', function (e) {
    const item = e.target.closest('.grid__item');
    if (!item) return;
    setActive(item, true);
  }, { passive: true });
  document.addEventListener('touchend', function (e) {
    const item = e.target.closest('.grid__item');
    if (!item) return;
    setTimeout(() => setActive(item, false), 300);
  }, { passive: true });
})();
